export default __webpack_public_path__ + "static/media/smart-home-energy-bg.21e9e3f5.jpeg";